/* eslint-disable react/prop-types */
import React, { useEffect, useState } from "react";
import { Box, Input, Switch, Typography } from "@mui/material";
import { v4 as uuidV4 } from "uuid";

import Footer from "./footer";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";

const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
  fontSize: 13,
};

const thTdStyle = {
  border: "1px solid black",
  textAlign: "left",
  padding: "8px",
  fontWeight: 400,
};

const selectStyle = {
  fontSize: "0.875rem",
  color: "#495057",
  border: "0.0625rem solid #d2d6da",
  background: "#fff",
  padding: "0.5rem 0.75rem",
  width: "100%",
  borderRadius: "0.5rem",
  outline: "none",
  minWidth: 100,
};

const Td = ({ children, style, row, ...rest }) => {
  return (
    <th {...rest} style={{ ...thTdStyle, ...style }}>
      {children}
    </th>
  );
};

const dataTable = [
  {
    id: uuidV4(),
    index: "1",
    note: "",
    isSave: false,
    title: "Cơ cấu tổ chức",
  },
  {
    id: uuidV4(),
    index: "1.1",
    isSave: false,
    note: "",
    title:
      "Sơ đồ minh họa cơ cấu sở hữu; cơ cấu pháp lý của tập đoàn và vị trí địa lý của các công ty con thuộc tập đoàn đang hoạt động.",
  },
  {
    id: uuidV4(),
    index: "2",
    isSave: false,
    note: "",
    title: "Thông tin về hoạt động kinh doanh của tập đoàn gồm:",
  },
  {
    id: uuidV4(),
    index: "2.1",
    isSave: false,
    note: "",
    title: "Các yếu tố chỉnh và kênh quan trọng tạo lợi nhuận kinh doanh.",
  },
  {
    id: uuidV4(),
    index: "2.2",
    isSave: false,
    note: "",
    title:
      "Mô tả về chuỗi cung ứng của 05 sản phẩm và/hoặc dịch vụ lớn nhất của Tập đoàn tỉnh theo doanh thu và bất kỳ hàng hóa và/hoặc dịch vụ nào chiếm hơn 5% doanh thu Tập đoàn, bao gồm thông tin về thị trường địa lý chính của các hàng hóa, dịch vụ này. Mô tả có thể dưới hình thức sơ đồ hoặc biểu đồ",
  },
  {
    id: uuidV4(),
    index: "2.3",
    isSave: false,
    note: "",
    title:
      "Danh sách và mô tả ngắn gọn các thỏa thuận dịch vụ trọng yếu giữa các thành viên của tập đoàn, không gồm các dịch vụ nghiên cứu phát triển (R&D), bao gồm mô tả năng lực của các trụ sở chính (cấp toàn cầu và cấp vùng) cung cấp các dịch vụ quan trọng và các chính sách giá chuyển nhượng để phân bổ chi phí dịch vụ và xác định giá phải trả cho các dịch vụ nội bộ tập đoàn. Tóm tắt và giải trình lý do chính trong trường hợp Tập đoàn tiến hành hoạt động mua sắm và quảng cáo, tiếp thị thông qua các trung tâm mua sắm và trung tâm tiếp thị tập trung.",
  },
  {
    id: uuidV4(),
    index: "2.4",
    isSave: false,
    note: "",
    title: "Mô tả các thị trường địa lý chính của các sản phẩm của tập đoàn nêu tại mục 2,2",
  },
  {
    id: uuidV4(),
    index: "2.5",
    isSave: false,
    note: "",
    title:
      "Mô tả bằng văn bản về phân tích chức năng đưa ra các đóng góp của trụ sở chính đối với các giá trị do các cơ sở kinh doanh bản địa trong tập đoàn tạo ra, ví dụ các chức năng trọng yếu được thực hiện, các rủi ro trọng yếu phải gánh chịu và các tài sản trọng yếu được sử dụng.",
  },
  {
    id: uuidV4(),
    index: "2.6",
    isSave: false,
    note: "",
    title:
      "Mô tả về các giao dịch tái cơ cấu kinh doanh trọng yếu, các hoạt động mua bán, sáp nhập phát sinh trong năm tài chính",
  },
  {
    id: uuidV4(),
    index: "3",
    isSave: false,
    note: "",
    title: "Thông tin về tài sản vô hình (TSVH) của tập đoàn:",
  },
  {
    id: uuidV4(),
    index: "3.1",
    isSave: false,
    note: "",
    title:
      "Mô tả tổng quan về chiến lược chung của MNE với việc phát triển, sở hữu và khai 3.1 thác TSVH, bao gồm vị trí của các cơ sở nghiên cứu phát triển (R&D) trụ sở chính và vị trí của nơi quản lý R&D",
  },
  {
    id: uuidV4(),
    index: "3.2",
    isSave: false,
    note: "",
    title:
      "Danh mục các TSVH hoặc nhóm các TSVH của tập đoàn có tác động trọng yếu 3.2 |đối với chính sách giá chuyển nhượng và các công ty sở hữu về mặt pháp lý đối với TSVH hoặc nhóm TSVH đó",
  },
  {
    id: uuidV4(),
    index: "3.3",
    isSave: false,
    note: "",
    title:
      "Danh sách các thỏa thuận quan trọng giữa các bên liên kết liên quan đến TSVH, 3.3 |thỏa thuận đóng góp chi phí, thỏa thuận dịch vụ nghiên cứu và các thỏa thuận cấp giấy phép, nhượng quyền",
  },
  {
    id: uuidV4(),
    index: "3.4",
    isSave: false,
    note: "",
    title:
      "Mô tả chung về các chính sách giá chuyển nhượng của tập đoàn đối với các hoạt động R&D và TSVH",
  },
  {
    id: uuidV4(),
    index: "3.5",
    isSave: false,
    note: "",
    title:
      "Mô tả chung về bất kỳ chuyển nhượng lợi ích quan trọng đối với TSVH giữa các bên liên kết trong năm tài chính liên quan, bao gồm thông tin các công ty con, các quốc gia tham gia chuyển nhượng và các khoản thanh toán liên quan",
  },
  {
    id: uuidV4(),
    index: "4",
    isSave: false,
    note: "",
    title: "Các hoạt động tài chính nội bộ tập đoàn:",
  },
  {
    id: uuidV4(),
    index: "4.1",
    isSave: false,
    note: "",
    title:
      "Mô tả chung về cơ chế phân bố tài chính của tập đoàn, bao gồm các thỏa thuận tài chính, thỏa thuận cấp vốn quan trọng với các bên cho vay độc lập",
  },
  {
    id: uuidV4(),
    index: "4.2",
    isSave: false,
    note: "",
    title:
      "Thông tin xác định bất kỳ thành viên nào của tập đoàn cung cấp chức năng tài chính, vốn tập trung cho tập đoàn, bao gồm các quốc gia nơi thành lập công ty con và nơi đặt trụ sở điều hành thực tế của công ty con",
  },
  {
    id: uuidV4(),
    index: "4.3",
    isSave: false,
    note: "",
    title:
      "Mô tả chung về chính sách giá chuyển nhượng của tập đoàn đối với các thỏa thuận tài chính, cấp vốn giữa các bên liên kết",
  },
  {
    id: uuidV4(),
    index: "5",
    isSave: false,
    note: "",
    title: "Kết quả kinh doanh và nghĩa vụ thuế của tập đoàn:",
  },
  {
    id: uuidV4(),
    index: "5.1",
    isSave: false,
    note: "",
    title:
      "Báo cáo tài chính hợp nhất năm kê khai của tập đoàn và các báo cáo, cơ chế tài chính, quản lý nội bộ phục vụ mục đích tính thuế của tập đoàn; thuế suất áp dụng xác định nghĩa vụ thuế tương ứng lợi nhuận thu được từ hoạt động sản xuất kinh doanh của các bên liên kết có giao dịch liên kết với người nộp thuế",
  },
  {
    id: uuidV4(),
    index: "5.2",
    isSave: false,
    note: "",
    title:
      "Danh sách mô tả ngắn gọn về các thỏa thuận trước về phương pháp xác định giá 5.2 |(APA) đơn phương và các chính sách thuế khác liên quan đến việc phân bổ thu nhập giữa các quốc gia",
  },
];

export default function CorporateIncomeTaxTable19({ setFieldValue }) {
  const [data, setData] = useState(dataTable);

  useEffect(() => {
    setFieldValue("valuesTable", data);
  }, [data]);

  const handleChange = (values) => {
    const { id, name, value } = values;
    setData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return { ...item, [name]: value };
        }
        return item;
      })
    );
  };

  const isDisabled = (index) => ["1", "2", "3", "4", "5"].includes(index);

  return (
    <Box display="flex" flexDirection="column" mt={5}>
      <Box display="flex">
        <Typography variant="h5">
          Công ty báo cáo các thông tin, tài liệu đã chuẩn bị và lưu trữ theo quy định tại phụ lục
          III, như sau:
        </Typography>
      </Box>
      <Box>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                STT
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Tài liệu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Đã nhập và lưu
              </Td>
              <Td rowSpan={1} style={{ textAlign: "center", background: "#d7d7d7" }}>
                Ghi chú
              </Td>
            </tr>

            {data.map((item, index) => (
              <tr key={item.id}>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  {item.index}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "left",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                    maxWidth: 500,
                  }}
                >
                  {item.title}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "center",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                    maxWidth: 100,
                  }}
                >
                  {isDisabled(item.index) ? (
                    ""
                  ) : (
                    <Switch
                      checked={item.isSave}
                      onChange={({ target: { checked } }) =>
                        handleChange({ id: item.id, value: checked, name: "isSave" })
                      }
                    />
                  )}
                </Td>
                <Td
                  rowSpan={1}
                  style={{
                    textAlign: "right",
                    background: isDisabled(item.index) ? "#ddeff3" : "transparent",
                  }}
                >
                  {isDisabled(item.index) ? (
                    ""
                  ) : (
                    <InputTable
                      type="text"
                      id={item.id}
                      value={item.note}
                      name="note"
                      onChange={handleChange}
                    />
                  )}
                </Td>
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

function InputTable(props) {
  const { onChange, id, ...rest } = props;
  const regexNumber = /^(0|[1-9]\d*)?$/;

  function handleChange(event) {
    const { name, value } = event.target;
    const newValue = value === "0" ? "" : value;
    if (!regexNumber.test(newValue)) return;
    onChange({ value: newValue !== "" ? +newValue : "", name, id });
  }
  return (
    <input
      type="text"
      style={{
        textAlign: "right",
        fontSize: 13,
        color: "#495057",
        border: "0.0625rem solid #d2d6da",
        background: "#fff",
        padding: "0.5rem 0.75rem",
        width: "100%",
        borderRadius: "0.5rem",
        outline: "none",
      }}
      onChange={handleChange}
      {...rest}
    />
  );
}
